import { supabase } from "@/lib/supabase";

const KEY = "heroOrAVillain:introSeen";

export function getIntroSeenLocal(): boolean {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(KEY) === "true";
}

// Fired (same-tab) the moment the intro is marked seen, so listeners mounted
// before the flag flipped — e.g. the daily-reward popup, which holds off until
// the intro is dismissed — can react without waiting for a page refresh.
export const INTRO_SEEN_EVENT = "hoav:intro-seen";

export function setIntroSeenLocal(): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(KEY, "true");
  window.dispatchEvent(new Event(INTRO_SEEN_EVENT));
}

export async function setIntroSeenRemote(userId: string): Promise<void> {
  const { error } = await supabase
    .from("profiles")
    .update({ intro_seen: true })
    .eq("id", userId);
  if (error) throw error;
}
